import * as Api from '@/helpers/restApi'

export default {
  state: {
    StructureData: null,
    UploadFileName: null
  },
  getters: {
    getStructureData: state => state.StructureData,
    getUploadFileName: state => state.UploadFileName
  },
  mutations: {
    SetStructureData (state, val) {
      state.StructureData = val
      // перезаписываем имя загруженного файла на имя файла, которое пришло с бека
      state.UploadFileName = val?.Block2[0]?.InfoFileName
    },
    SetUploadFileName (state, val) {
      state.UploadFileName = val
    }
  },
  actions: {
    setStructureData ({ state, dispatch, commit }) {
      // получаем данные для блока структура и органы управления образовательной организацией раздела сведения об образовательной организации
      Api.getApi({
        url: '/api/EduCompanyInfo/GetStructureSection'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            commit('SetStructureData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateStructure ({ dispatch }, obj) {
      // обновляем блок и получаем обновленные данные с бека
      Api.putApi({
        url: '/api/EduCompanyInfo/UpdateStructureSection',
        payload: obj
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setStructureData')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
